<template>
  <DialogWrapper
    close-on-cancel
    class="invite-portal-questionnaire-dialog"
    saveBtnLabelI18nKey="common.btn.submit"
    :show.sync="show"
    :loading="loading"
    :titleI18nKey="`${i18nPrefix}.title`"
    @save="handleSave"
  >
    <WrappedForm
      ref="form"
      :model="invitation"
      :formLines="formLines"
    ></WrappedForm>
  </DialogWrapper>
</template>

<script>
import _ from 'lodash'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import WrappedForm from '@/components/formEditor/wrappedForm.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    DialogWrapper,
    WrappedForm
  },
  props: {
    jobId: {
      required: false
    },
    isAllApplication: {
      default: false
    },
    applicationList: {
      required: true
    },
    searchParams: {
      required: false
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.invitation.portalQuestionnaire',
      show: false,
      loading: false,
      questionnaireList: [],
      emailTemplateList: [],
      loader: null,
      invitation: {}
    }
  },
  computed: {
    formLines () {
      const i18nPrefix = this.i18nPrefix
      const requiredMessage = this.$t('common.message.requiredFormField')
      const lines = {
        questionnaire: {
          elType: 'el-select',
          label: this.$t(`${i18nPrefix}.label.questionnaire`),
          option: {
            data: this.questionnaireList,
            labelKey: 'name',
            valueKey: 'id'
          },
          props: { filterable: true },
          rules: [{ required: true, message: requiredMessage, trigger: 'blur' }]
        },
        emailTemplate: {
          elType: 'el-select',
          label: this.$t(`${i18nPrefix}.label.emailTemplate`),
          option: {
            data: this.emailTemplateList,
            labelKey: 'name',
            valueKey: 'id'
          },
          props: { filterable: true },
          rules: [{ required: true, message: requiredMessage, trigger: 'blur' }]
        }
      }
      return lines
    },
    form () {
      return this.$refs.form
    }
  },
  created () {

  },
  methods: {
    ...mapActions('postApplicantManagement', ['searchQuestionnaire', 'createInvitation']),
    ...mapActions('notificationTemplate', ['getCompanyEmailTemplateByType']),
    openDialog () {
      this.show = true
    },
    clearForm () {
      this.invitation = {}
      this.$nextTick(() => {
        this.form.clearValidate()
      })
    },
    async loadData () {
      this.loading = true
      if (!this.loader) {
        this.loader = Promise.all([
          this.searchQuestionnaire({ just_active_list: true, only_candidate: true }).then(resp => {
            this.questionnaireList = resp.questionnaires
          }),
          this.getCompanyEmailTemplateByType({
            email_template_type: 'Experience Portal Invitation'
          }).then(resp => {
            const companyEmailTemplateList = _.filter(resp || [], item => item.company_id !== null)
            this.emailTemplateList = _.map(companyEmailTemplateList, item => ({ ...item, disabled: false }))
          })
        ])
      }
      await this.loader
      this.loading = false
    },
    async handleSave () {
      if (this.loading) {
        return
      }
      const isValid = await this.form.submit()
      if (!isValid) {
        return
      }
      this.loading = true
      const invitation = {
        is_all_application: this.isAllApplication,
        search_params: this.searchParams,
        questionnaire_id: this.invitation.questionnaire,
        ids: _.map(this.applicationList, item => item.candidate.id),
        job_id: this.jobId,
        email_template_id: this.invitation.emailTemplate,
        invitation_target: 'candidate'
      }
      const resp = await this.createInvitation(invitation)
      this.loading = false
      if (resp) {
        if (resp.has_already_invited_ids && resp.has_already_invited_ids.length > 0) {
          this.$message.success(resp.message)
        } else {
          this.$message.success(this.$t(`${this.i18nPrefix}.message.inviteSuccess`))
        }
        this.show = false
      } else {
        this.$message.error(this.$t(`${this.i18nPrefix}.message.inviteFail`))
      }
    }
  },
  watch: {
    show () {
      if (this.show) {
        this.clearForm()
        this.loadData()
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
